import fetch from 'auth/FetchInterceptor'

const PipelineService = {
  getAll: (params = null) =>
    fetch({ url: '/crm/pipelines', method: 'get', params }),
  get: (id) => fetch({ url: `/crm/pipelines/${id}`, method: 'get' }),
  create: (data) => fetch({ url: '/crm/pipelines', method: 'post', data }),
  update: (id, data) =>
    fetch({ url: `/crm/pipelines/${id}`, method: 'patch', data }),
  remove: (id) => fetch({ url: `/crm/pipelines/${id}`, method: 'delete' }),
  reorder: (pipelineIds) =>
    fetch({
      url: '/crm/pipelines/reorder',
      method: 'post',
      data: { pipelineIds },
    }),
}

export default PipelineService
